import merge from 'lodash/merge';

import { ConnectProvider } from 'api/onboarding/repositoryConnect';
import { FormStyles } from 'components/DataEntry/Form/types';
import { IconTypes } from 'components/Icons';

export const getRepoPlaceholder = provider => {
  switch (provider) {
    case IconTypes.Gitlab:
      return 'https://gitlab.com/orgname/repo';
    default:
      return '';
  }
};

// Auto-connect constants moved here from RepositoryAutoConnect so the
// component file only holds the Form-based component.
export const REPOSITORY_NAME_PATTERN = /^[a-zA-Z0-9-]*$/;

export const autoConnectCopy: Record<
  ConnectProvider,
  { button: string; note: string; fallbackError: string }
> = {
  gitlab: {
    button: 'CONNECT GITLAB',
    note:
      'Creates a service account in this group with the Owner role and a ' +
      'read-only token (read_api, read_repository and read_registry scopes, ' +
      'rotated automatically), so Ariksa can read group security settings ' +
      'and scan repositories and container images. Requires the Owner role. Service ' +
      'accounts do not use a GitLab seat.',
    fallbackError: 'Could not start the GitLab connection.',
  },
  github: {
    button: 'INSTALL GITHUB APP',
    note:
      'Installs the Ariksa GitHub App with read-only permissions. Access ' +
      'uses short-lived tokens and can be revoked from GitHub at any time.',
    fallbackError: 'Could not start the GitHub App installation.',
  },
};

// Layout shared by the token and auto-connect forms: the Form's outer row is
// already full width, so pin the form to the fixed theme `formWidth` and let
// the help panel take only the remaining space (flex basis 0) instead of a
// fixed 50%, which used to shrink the form.
export const getRepositoryFormStyles = (styles?: FormStyles): FormStyles =>
  merge({}, styles, {
    form: {
      formWidth: 'formWidth',
      helpWrapper: { w: 'auto', flex: 1, minW: 0 },
    },
  });
